import {isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish, currencyCodes, CurrencyCodeType} from 'shared/web';

export const isCurrency = (val: string | Nullish): val is CurrencyCodeType =>
  isNotNilOrEmpty(val) && currencyCodes.includes(val as CurrencyCodeType);
